import React, { useContext } from 'react';
import Col from '../../UIcomponent/Column';
import BookingModalDic from './BookingModalDic';
import { PublicDic } from '../../Utility/PublicDic';
import { ThemeContext } from 'styled-components';

const BookingModalLessons = (props) => {
  const { lang, sessionSelect, lessons, hadTrial } = props;
  const theme = useContext(ThemeContext);
  return (
    <Col
      xl={12}
      lg={12}
      md={18}
      sm={18}
      xs={21}
      className="c__Booking__Modal__Session"
    >
      {lessons &&
        !hadTrial &&
        lessons
          .filter((each) => each.IsTrial === true)
          .map((lesson) => {
            return lesson.Packages.map((pack, index) => {
              return (
                <Col
                  onClick={() =>
                    sessionSelect(
                      lesson.ID,
                      lesson.TeacherID,
                      pack.ID,
                      pack.SingleSessionPrice
                    )
                  }
                  className="o__Booking__Modal__Session"
                  style={{
                    backgroundColor: pack.isSelected && '#edf2fa',
                  }}
                >
                  <Col
                    xl={14}
                    lg={14}
                    md={14}
                    sm={7}
                    xs={7}
                    className="o__Booking__Modal__Session__Type"
                  >
                    <Col>{BookingModalDic.trial[`${lang}`]}</Col>
                    <Col>
                      {pack.SessionLengthInMinute * pack.PackageSessionCount +
                        ' ' +
                        PublicDic.minute[`${lang}`]}
                    </Col>
                    {/* <Col>{pack.SessionLengthInMinute * pack.PackageSessionCount + ' ' + PublicDic.minute[`${lang}`]}</Col> */}
                  </Col>
                  <Col
                    xl={10}
                    lg={10}
                    md={10}
                    sm={15}
                    xs={15}
                    className="o__Booking__Modal__Session__Price"
                  >
                    <Col
                      style={{
                        backgroundColor: 'transparent',
                        // fontWeight: pack.SingleSessionPrice === 0 && '600',
                        // color: checkDiscount && theme.danger
                      }}
                    ></Col>
                    <Col>
                      {/* {pack.SingleSessionPrice === 0
                        ? PublicDic.free[`${lang}`]
                        : (pack.SingleSessionPrice / 10).toLocaleString(lang) +
                          ' ' +
                          PublicDic.Toman} */}
                      {PublicDic.free[`${lang}`]}
                    </Col>
                  </Col>
                </Col>
              );
            });
          })}
      {lessons &&
        lessons
          .filter((each) => each.IsTrial === false)
          .map((lesson) => {
            return lesson.Packages.map((pack) => {
              let checkDiscount =
                pack.PackageSessionCount > 1 &&
                lesson.Packages[1].SingleSessionPrice -
                  pack.SingleSessionPrice >
                  0;

              return (
                <Col
                  onClick={() =>
                    sessionSelect(
                      lesson.ID,
                      lesson.TeacherID,
                      pack.ID,
                      pack.SingleSessionPrice
                    )
                  }
                  className="o__Booking__Modal__Session"
                  style={{
                    backgroundColor: pack.isSelected && '#edf2fa',
                  }}
                >
                  <Col
                    xl={14}
                    lg={14}
                    md={14}
                    sm={7}
                    xs={7}
                    className="o__Booking__Modal__Session__Type"
                  >
                    <Col>
                      {pack.PackageSessionCount === 0
                        ? BookingModalDic.trial[`${lang}`]
                        : pack.PackageSessionCount + ' جلسه '}
                    </Col>
                    <Col>
                      {pack.PackageSessionCount === 1
                        ? pack.SessionLengthInMinute +
                          ' ' +
                          PublicDic.minute[`${lang}`]
                        : ` هر جلسه ${
                            pack.SessionLengthInMinute +
                            ' ' +
                            PublicDic.minute[`${lang}`]
                          }`}
                    </Col>
                    {/* <Col>{pack.SessionLengthInMinute * pack.PackageSessionCount + ' ' + PublicDic.minute[`${lang}`]}</Col> */}
                  </Col>
                  <Col
                    xl={10}
                    lg={10}
                    md={10}
                    sm={15}
                    xs={15}
                    className="o__Booking__Modal__Session__Price"
                    // style={{
                    //     display: checkDiscount
                    // }}
                  >
                    <Col
                      style={{
                        backgroundColor: !checkDiscount && 'transparent',
                        fontWeight: pack.SingleSessionPrice === 0 && '600',
                        color: checkDiscount && theme.danger,
                      }}
                    >
                      {checkDiscount &&
                        Math.round(
                          (
                            (100 *
                              (lesson.Packages[1].SingleSessionPrice -
                                pack.SingleSessionPrice)) /
                            lesson.Packages[1].SingleSessionPrice
                          ).toFixed(1)
                        ) +
                          '%' +
                          ' تخفیف '}
                    </Col>
                    <Col
                      style={{
                        backgroundColor:
                          pack.SingleSessionPrice === 0 && '#edf2fa',
                        fontWeight: pack.SingleSessionPrice === 0 && '600',
                      }}
                    >
                      {pack.SingleSessionPrice === 0
                        ? PublicDic.free[`${lang}`]
                        : (pack.SingleSessionPrice / 10).toLocaleString(lang) +
                          ' تومان '}
                    </Col>
                  </Col>
                </Col>
              );
            });
          })}
    </Col>
  );
};

export default BookingModalLessons;
